export namespace metrics {
  export function emitMetric(name: string, value: number, dimensions?: { [key: string]: string }) {}
}
